import {useEffect, useRef, useState} from 'react';

import Config from '../../utils/Configuration';
import _ from 'lodash';

export const processAemHeaderFooterHtml = (html, alternativeStyleSheets, onLoadStyleSheet) => {
    const baseUrl = Config.apiConfig.webURL;

    let processedHtml = html.replace(/(src|href)="\/([^"]*)"/g, `$1="${baseUrl}/$2"`);

    // Add the new stylesheet
    alternativeStyleSheets.forEach((link) => {
        const styleSheet = document.createElement('link');
        styleSheet.rel = 'stylesheet';
        styleSheet.href = link;
        document.head.appendChild(styleSheet);
        styleSheet.onload = () => onLoadStyleSheet(link);
    });

    // Remove any link tags from the fetched HTML to avoid conflicts
    processedHtml = processedHtml.replace(/<link rel="stylesheet"[^>]*>/g, '');
    // // Extract and execute scripts
    const scriptTags = processedHtml.match(/<script\b[^>]*>[\s\S]*?<\/script>/gi) || [];
    scriptTags.forEach((tag) => {
        const script = document.createElement('script');
        const srcMatch = tag.match(/src="([^"]*)"/);
        if (srcMatch && srcMatch[1]) {
            // External script
            script.src = (srcMatch[1] || '').toString();
            script.async = false; // Ensure scripts execute in order
            document.body.appendChild(script);
        } else {
            // Inline script
            const inlineScript = tag.replace(/<script\b[^>]*>/i, '').replace(/<\/script>/i, '');
            script.innerHTML = inlineScript;
            document.body.appendChild(script);
        }
    });
    // Remove script tags from the HTML to avoid re-execution
    processedHtml = processedHtml.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
    // Remove meta tags from the HTML, assuming no meta tag is designed to co-operate with client
    processedHtml = processedHtml.replace(/<meta\b[^>]*>/gi, '');
    return processedHtml;
};

export default function Header(props) {
    const baseUrl = Config.apiConfig.webURL;
    const styleSheets = [
        `${baseUrl}/etc.clientlibs/mxs/clientlibs/rebrand-global-header.css`,
        `${baseUrl}/etc.clientlibs/mxs/clientlibs/rebrand-global-bootstrap-dependencies.css`
    ];
    const [loadingStyleSheets, setLoadingStyleSheets] = useState([...styleSheets]);

    const [html, setHtml] = useState('');

    useEffect(() => {
        _.isEmpty(props.headerDocument) && props.getHeader();
    }, []);

    useEffect(() => {
        if (typeof props.headerDocument === 'string') {
            const processedHtml = processAemHeaderFooterHtml(props.headerDocument, loadingStyleSheets, (link) =>
                setLoadingStyleSheets((value) => value.filter((item) => link !== item))
            );
            setHtml(processedHtml);
        }
    }, [props.headerDocument]);

    useEffect(() => {
        function applyMarginTopToNotifications() {
            const notifications = document.querySelectorAll('.rebrand .cmp-notification-message');

            if (notifications.length > 0) {
                notifications.forEach((notification) => {
                    notification.style.marginTop = 'var(--var-header-top)';
                });
            }
        }
        function hideLanguageDropdown() {
            const rightMenu = document.querySelector('.secondary-right');
            const dropdownMenus = document.querySelectorAll('#navbarDropdown-language');

            dropdownMenus.forEach((dropdownMenu) => {
                dropdownMenu.style.display = 'none';
                rightMenu.childNodes.forEach((child) => {
                    if (child.contains(dropdownMenu)) child.style.display = 'none';
                });
            });
        }
        // Call the function
        applyMarginTopToNotifications();
        hideLanguageDropdown();
    }, [html]);

    return (
        <>
            <div
                className={`header ${loadingStyleSheets.length > 0 ? 'd-none' : ''}`}
                dangerouslySetInnerHTML={{__html: html}}
            ></div>
        </>
    );
}
